import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";

import { SitePage } from "@/features/site/components/site-page";
import { usePublicDirectory } from "@/features/site/hooks/use-public-directory";
import { useSiteConfig } from "@/features/site/hooks/use-site-config";
import { Hero } from "@/features/site/modules/hero/hero";
import { HowItWorks } from "@/features/site/modules/how-it-works/how-it-works";
import { OpenCalendar } from "@/features/site/modules/open-calendar/open-calendar";
import { ServicesBand } from "@/features/site/modules/services-band/services-band";
import { ShopBand } from "@/features/site/modules/shop/shop";
import { Team } from "@/features/site/modules/team/team";
import { m } from "@/paraglide/messages.js";

export const Route = createFileRoute("/(public)/$trainerSlug/")({
  component: HomePage,
  loader: () => ({ crumb: m.landing_crumb() }),
  validateSearch: z.object({ redirect: z.string().optional() }),
});

/**
 * The studio's front page. The open calendar sits right under the hero because booking is the
 * point; everything after it is there for the visitor who is not ready to pick a time yet. Every
 * section shows the trainer's own data and steps aside when there is none.
 */
function HomePage() {
  // The hero and the sections below read the default week. The calendar asks for its own slice,
  // which starts out as this same request, so the first paint costs one round trip.
  const { calendarDays } = useSiteConfig();
  const { directory, loading } = usePublicDirectory({ days: calendarDays });

  return (
    <SitePage head={<Hero directory={directory} loading={loading} />}>
      <OpenCalendar />
      <ServicesBand directory={directory} loading={loading} />
      <ShopBand />
      <Team directory={directory} />
      <HowItWorks />
    </SitePage>
  );
}
